import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../context/LocaleContext';
import SEO from '../components/SEO';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const { localePath } = useLocale();
  return (
    <>
      <SEO
        title={t('notFound.title')}
        description={t('seo.notFound.description')}
        noindex={true}
      />
      <div className="container mx-auto px-4 py-16 text-center">
        <h1 className="text-4xl font-bold mb-4 text-brand-dark dark:text-brand-white">
          {t('notFound.title')}
        </h1>
        <p className="text-lg mb-8 text-gray-600 dark:text-gray-300">
          {t('notFound.message')}
        </p>
        <Link 
          to={localePath('/')}
          className="inline-flex items-center gap-2 px-6 py-3 bg-brand-blue text-white rounded-lg hover:bg-brand-dark transition-colors"
        >
          <FontAwesomeIcon icon={faArrowLeft} className="h-4 w-4" />
          <span>{t('notFound.backHome')}</span>
        </Link>
      </div>
    </>
  );
};

export default NotFound; 